<section>
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formConceptInvoicing">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col d-flex justify-content-start align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>
          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="delete()"></app-custom-button>
            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="conceptInvoicingContract.userNameCreate"
              [createDate]="conceptInvoicingContract.createDate"
              [userNameUpdate]="conceptInvoicingContract.userNameUpdate"
              [updateDate]="conceptInvoicingContract.updateDate"
              [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row p-2">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col field-code">
              <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true" [recovery]="true"
                (onChangeNumber)="changeCode($event)"></app-custom-input-number>
            </div>
            <div class="col field-alterCode">
              <app-custom-input-text formControlName="alterCode" [labelText]="'Cód. Alterno'" [maxLength]="10">
              </app-custom-input-text>
            </div>
            <div class="col field-alterCode2">
              <app-custom-input-text formControlName="alterCode2" [labelText]="'Cód. Alterno 2'" [maxLength]="10">
              </app-custom-input-text>
            </div>
            <div class="col field-name">
              <app-custom-input-text formControlName="name" [labelText]="'Nombre'" [required]="true" [maxLength]="70">
              </app-custom-input-text>
            </div>
            <div class="col field-cxcConcept" *ngIf="conceptInvoicingType === 1">
              <app-custom-input-text formControlName="cxcConcept" [labelText]="'Concepto CxC'" [maxLength]="10">
              </app-custom-input-text>
            </div>
            <div class="col field-conceptInvoicingPriceOfId" *ngIf="conceptInvoicingType === 1">
              <app-custom-select formControlName="conceptInvoicingPriceOfId" [labelText]="'Precio De'"
                [list]="listConceptInvoicingPriceOfs" [required]="true"></app-custom-select>
            </div>
            <div class="field-checkbox-affectsInventory" *ngIf="conceptInvoicingType === 1">
              <app-custom-checkbox formControlName="affectsInventory" [labelText]="'Afecta Inv.'"></app-custom-checkbox>
            </div>
            <div class="field-checkbox-promptPayment" *ngIf="conceptInvoicingType === 1">
              <app-custom-checkbox formControlName="promptPayment" [labelText]="'Dcto.P.Pago'"></app-custom-checkbox>
            </div>
            <div [hidden]="!swDispersedArticle" class="field-checkbox-swDispersedFamily">
              <app-custom-checkbox formControlName="swDispersedFamily" [labelText]="'Dispersa Familia'"
                (onChangeCheckBox)=" send()"></app-custom-checkbox>
            </div>
            <div [hidden]="!swDispersedArticle" class="col field-assign-families"
              *ngIf="formConceptInvoicing.get('swDispersedFamily')?.value">
              <app-custom-button [title]="'Asignar Familias'" [label]="'Asignar Familias'" [severity]="'success'"
                [variant]="'outlined'" [disabled]="disabledForm" [width]="'7.5rem'" (onClick)="assignFamilies()">
              </app-custom-button>
            </div>
            <app-custom-modal #assignFamiliesModal [label]="'Asignar Familias'" [header]="'Asignar Familias'"
              [children]="componentAssignFamilies" [inputs$]="inputsForAssignFamilies$" [width]="'50rem'" hidden>
            </app-custom-modal>
            <div class="col field-send">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="send()"></app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>